import { createAsyncSaga } from '@wahaaabello/redux-async-actions';
import { Action } from 'redux-actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../../api';
import { FetchTargetPageDataParams } from '../../../api';
import targetsActions from './actions';

function* fetchTarget({ payload: id }: Action<string>) {
  try {
    const data = yield call(api.fetchTargetData, id);
    yield put(
      targetsActions.fetchTargetSuccess({
        id,
        data
      })
    );
    return data;
  } catch (error) {
    yield put(targetsActions.fetchTargetFailure(error));
    throw error;
  }
}

function* fetchTargetPage({
  payload: { id, loadType }
}: Action<{ id: string; loadType: string }>) {
  try {
    const data = yield call(api.fetchTargetPageData, id, loadType);
    yield put(
      targetsActions.fetchTargetPageSuccess({
        id,
        loadType,
        data
      })
    );
    return data;
  } catch (error) {
    yield put(targetsActions.fetchTargetPageFailure(error));
    throw error;
  }
}

function* fetchTargets(params: FetchTargetPageDataParams) {
  try {
    const pageData = yield call(api.fetchTargetListPageData, params);
    yield put(
      targetsActions.fetchTargetsSuccess({
        params,
        pageData
      })
    );
    return pageData;
  } catch (error) {
    yield put(targetsActions.fetchTargetsFailure(error));
    throw error;
  }
}

function* fetchMyTargets({ payload: { limit = 10 } }) {
  const params: FetchTargetPageDataParams = {
    page: 'self',
    listtype: 'mysearchlist',
    searchtext: '',
    limit
  };
  return yield call(fetchTargets, params);
}

function* fetchTargetsByCategory({
  payload: { category = 'all', limit = 10 } = {}
}) {
  const params: FetchTargetPageDataParams = {
    page: 'explore',
    listtype: 'explorebycat',
    searchtext: category,
    limit
  };
  return yield call(fetchTargets, params);
}

function* searchTargets({ payload: { query = '', limit = 10 } = {} }) {
  const params: FetchTargetPageDataParams = {
    page: 'explore',
    listtype: 'searchlist',
    searchtext: query,
    limit
  };
  return yield call(fetchTargets, params);
}

export default function* targetsSaga() {
  yield all([
    takeLatest(
      targetsActions.fetchTargetRequest.toString(),
      createAsyncSaga(fetchTarget)
    ),
    takeLatest(
      targetsActions.fetchTargetPageRequest.toString(),
      createAsyncSaga(fetchTargetPage)
    ),
    takeLatest(
      targetsActions.fetchMyTargetsRequest.toString(),
      createAsyncSaga(fetchMyTargets)
    ),
    takeLatest(
      targetsActions.fetchTargetsByCategoryRequest.toString(),
      createAsyncSaga(fetchTargetsByCategory)
    ),
    takeLatest(
      targetsActions.searchTargetsRequest.toString(),
      createAsyncSaga(searchTargets)
    )
  ]);
}
